import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  containerized: {
    type: 'boolean',
    default: false,
  },
  hasNavigation: {
    type: 'boolean',
    default: true,
  },
  hasNavigationDesktop: {
    type: 'boolean',
    default: true,
  },
  loop: {
    type: 'boolean',
    default: false,
  },
  centered: {
    type: 'boolean',
    default: false,
  },
  cardSpace: {
    type: 'int',
    default: 35,
  },
  dots: {
    type: 'boolean',
    default: false,
  },
  slidesPerView: {
    type: 'number',
    default: 1,
  },
  slidesPerView768: {
    type: 'number',
    default: 2,
  },
  slidesPerView1280: {
    type: 'number',
    default: 3,
  },
  slidesPerView1580: {
    type: 'number',
    default: 3,
  },
  hasFakeItem: {
    type: 'boolean',
    default: false,
  },
  ...Common,
};
